import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Calendar = forwardRef<SVGSVGElement | null, IconFilledProps>(function Calendar({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.75 2C9.02614 2 9.25 2.22386 9.25 2.5V4H15.75V2.5C15.75 2.22386 15.9739 2 16.25 2H16.75C17.0261 2 17.25 2.22386 17.25 2.5V4H19.5C20.6046 4 21.5 4.89543 21.5 6V19C21.5 20.1046 20.6046 21 19.5 21H5.5C4.39543 21 3.5 20.1046 3.5 19V6C3.5 4.89543 4.39543 4 5.5 4H7.75V2.5C7.75 2.22386 7.97386 2 8.25 2H8.75ZM8.25 7C7.97386 7 7.75 6.77614 7.75 6.5V5.5H5.5C5.22386 5.5 5 5.72386 5 6V9.75H20V6C20 5.72386 19.7761 5.5 19.5 5.5H17.25V6.5C17.25 6.77614 17.0261 7 16.75 7H16.25C15.9739 7 15.75 6.77614 15.75 6.5V5.5H9.25V6.5C9.25 6.77614 9.02614 7 8.75 7H8.25ZM20 11.25H5V19C5 19.2761 5.22386 19.5 5.5 19.5H19.5C19.7761 19.5 20 19.2761 20 19V11.25Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M7.75 6.5C7.75 6.77614 7.97386 7 8.25 7H8.75C9.02614 7 9.25 6.77614 9.25 6.5V4H15.75V6.5C15.75 6.68848 15.8545 6.8526 16.0083 6.93781C16.0796 6.97742 16.1621 7 16.25 7H16.75C16.9336 7 17.0938 6.90137 17.1807 6.75427C17.2246 6.67975 17.25 6.59283 17.25 6.5V4H19.5C20.6045 4 21.5 4.89545 21.5 6V9.75H3.5V6C3.5 4.89545 4.39551 4 5.5 4H7.75V6.5Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          d='M7.75 4V2.5C7.75 2.22386 7.97386 2 8.25 2H8.75C9.02614 2 9.25 2.22386 9.25 2.5V4H7.75Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          d='M17.25 4H15.75V2.5C15.75 2.25024 15.9331 2.04321 16.1724 2.00592C16.1978 2.00201 16.2236 2 16.25 2H16.75C17.0264 2 17.25 2.22388 17.25 2.5V4Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          d='M21.5 11.25H3.5V19C3.5 20.1046 4.39543 21 5.5 21H19.5C20.6046 21 21.5 20.1046 21.5 19V11.25Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'calendar-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Calendar;
